import { Box, Database, Layout, Layers, List } from 'lucide-react';

import { EnvironmentId } from '@/react/portainer/environments/types';
import { useIsEdgeAdmin } from '@/react/hooks/useUser';

import { SidebarItem } from '../SidebarItem';

interface Props {
  environmentId: EnvironmentId;
}

export function EdgeDeviceAsyncSidebar({ environmentId: endpointId }: Props) {
  const { isAdmin, isLoading } = useIsEdgeAdmin({
    forceEnvironmentId: endpointId,
  });

  return (
    <>
      <SidebarItem
        to="edge.browse.dashboard"
        params={{ endpointId }}
        icon={Layout}
        label="Dashboard"
        data-cy="edgeDeviceSidebar-dashboard"
      />

      {!isLoading && isAdmin && (
        <SidebarItem
          to="edge.browse.stacks"
          params={{ endpointId }}
          icon={Layers}
          label="Stacks"
          data-cy="edgeDeviceSidebar-stacks"
        />
      )}

      <SidebarItem
        to="edge.browse.containers"
        params={{ endpointId }}
        icon={Box}
        label="Containers"
        data-cy="edgeDeviceSidebar-containers"
      />

      <SidebarItem
        to="edge.browse.images"
        params={{ endpointId }}
        icon={List}
        label="Images"
        data-cy="edgeDeviceSidebar-images"
      />

      <SidebarItem
        to="edge.browse.volumes"
        params={{ endpointId }}
        icon={Database}
        label="Volumes"
        data-cy="edgeDeviceSidebar-volumes"
      />
    </>
  );
}
